<div
  class="project-dropdown form-group"
  [class.show]="isProjectDropdownOpen"
  [class.project-dropdown--compact]="compact"
  [class.project-dropdown--embedded]="embedded"
>
    <button
      type="button"
      class="btn btn-outline-dark dropdown-toggle d-flex align-items-center"
      [class.w-100]="!embedded"
      [class.justify-content-between]="!embedded"
      [class.form-select]="!compact"
      (click)="toggleProjectDropdown($event)"
      [disabled]="disabled"
      [attr.aria-expanded]="isProjectDropdownOpen"
    >
      <span class="project-dropdown-selection d-flex align-items-center gap-2">
        @if (selectedProject) {
        <span
          class="project-color-dot"
          [style.background-color]="resolveProjectColor(selectedProject)"
          aria-hidden="true"
        ></span>
        <span
          class="project-dropdown-name"
          [attr.title]="selectedProject.name"
          >{{ selectedProject.name }}</span>
        } @else {
        <span class="project-dropdown-name">{{ nullOptionLabel }}</span>
        }
      </span>
      <i
        class="bi project-dropdown-chevron flex-shrink-0"
        [ngClass]="isProjectDropdownOpen ? 'bi-chevron-up' : 'bi-chevron-down'"
      ></i>
    </button>
    <ul
      class="dropdown-menu w-100"
      [class.dropdown-menu-end]="!compact"
      [class.show]="isProjectDropdownOpen && !disabled"
      [attr.data-bs-popper]="isProjectDropdownOpen && !disabled ? 'static' : null"
      (click)="$event.stopPropagation()"
    >
      <li class="project-dropdown-search-item">
        <input
          #searchInput
          type="search"
          class="form-control project-dropdown-search"
          placeholder="Search projects…"
          autocomplete="off"
          [ngModel]="projectSearchTerm()"
          (ngModelChange)="projectSearchTerm.set($event)"
          (keydown.escape)="onSearchEscape($event)"
        />
      </li>
      @if (shouldShowNullOption()) {
      <li>
        <button
          class="dropdown-item d-flex align-items-center gap-2"
          type="button"
          (click)="onProjectSelected(null)"
          [class.active]="selectedProject === null || selectedProject === undefined"
          [disabled]="disabled"
        >
          <span>{{ nullOptionLabel }}</span>
        </button>
      </li>
      }
      @if (showEmptyListState()) {
      <li>
        <span class="dropdown-item-text text-muted px-3 py-2 d-block">
          {{ emptyListMessage() }}
        </span>
      </li>
      }
      @for (project of filteredProjects(); track project.id) {
      <li>
        <button
          class="dropdown-item d-flex align-items-center gap-2"
          type="button"
          (click)="onProjectSelected(project)"
          [class.active]="selectedProject?.id === project.id"
          [disabled]="disabled"
        >
          <span
            class="project-color-dot"
            [style.background-color]="resolveProjectColor(project)"
            aria-hidden="true"
          ></span>
          <span [attr.title]="project.name">{{ project.name }}</span>
        </button>
      </li>
      }
    </ul>
  </div>
